import { configureStore } from "@reduxjs/toolkit";
import { MainReducer } from "./MainReducers";
const dhWebAppstore = configureStore({
    reducer : MainReducer
});

export default dhWebAppstore
